var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"main"},[_c('left'),_c('div',{staticClass:"right"},[_c('router-view')],1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"header-container"},[_c('p',{staticClass:"header-title"},[_vm._v("前端规范")])])])
}]

export { render, staticRenderFns }